import { h } from "preact";
import { useEffect, useState } from "preact/hooks";
import useDesigners from "../helpers/useDesigners";
import DesignersList from "./designersList";
import DesignersLetters from "./designersLetters";
import DesignersChips from "./designersChips";

export default function DesignersContent({ data }) {
  const [designersData] = useDesigners();
  const [sortedDesigners, setSortedDesigners] = useState([]);

  useEffect(() => {
    const designersMap = {};

    designersData.forEach((designer) => {
      const firstLetter = designer.name[0].toUpperCase();

      if (firstLetter in designersMap) {
        designersMap[firstLetter].push(designer);
      } else {
        designersMap[firstLetter] = [designer];
      }
    });

    const designersArray = Object.entries(designersMap)
      .map(([title, designers]) => ({
        title,
        designers: designers.sort((a, b) => a.name.localeCompare(b.name)),
      }))
      .sort((a, b) => a.title.localeCompare(b.title));

    setSortedDesigners(designersArray);
  }, [designersData]);

  return (
    <div>
      {data.show_designer_chips && (
        <DesignersChips
          initialFollowDesigners={data.follow_designers}
          designersData={designersData}
        />
      )}
      <DesignersLetters designers={sortedDesigners} idPrefix={data.id_prefix} />
      <ul className="designers__entries-list">
        {sortedDesigners.map(({ title, designers }) => (
          <DesignersList
            designers={designers}
            title={title}
            idPrefix={data.id_prefix}
            loggedIn={data.logged_in}
          />
        ))}
      </ul>
    </div>
  );
}
